import React, { FC } from "react";
import { Button } from "@pancakeswap/uikit";
import * as S from "./GameOver.style";

interface GameOverProps {
  isWin: boolean;
  onRetry: () => void; // Újrakezdés függvény
}

const GameOver: FC<GameOverProps> = ({ isWin, onRetry }) => {
  return (
    <S.Wrapper
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1, duration: 0.5 }}
    >
      <div>
        <h2>{isWin ? "Congratulations!" : "Game Over"}</h2>
        {!isWin && (
          <Button onClick={onRetry} variant="secondary" mt="20px">
            Retry
          </Button>
        )}
      </div>
    </S.Wrapper>
  );
};

export default GameOver;
